import { useTranslate } from '@refinedev/core';
import { Card, Descriptions, Typography } from 'antd';
import type { DescriptionsProps } from 'antd';
import type { CollectionOut } from '@/api/generated/schemas';
import { orDash, useVerticalDescProps } from '@/components/common/show/shared';
import { formatDateTime } from '@/utils/format';

const { Text } = Typography;

interface CollectionGeneralTabProps {
  record: CollectionOut;
}

export const CollectionGeneralTab = ({ record }: CollectionGeneralTabProps) => {
  const t = useTranslate();
  const verticalDescProps = useVerticalDescProps();

  const items: DescriptionsProps['items'] = [
    {
      key: 'id',
      label: t('base.fields.id'),
      children: orDash(record.id),
    },
    {
      key: 'name',
      label: t('user_catalog.collections.fields.name'),
      children: orDash(record.name),
    },
    {
      key: 'slug',
      label: t('user_catalog.collections.fields.slug'),
      children: orDash(record.slug && <Text code>{record.slug}</Text>),
    },
    {
      key: 'collection_kind',
      label: t('user_catalog.collections.fields.collection_kind'),
      children: orDash(
        t(`user_catalog.collections.kind.${record.collection_kind}`)
      ),
    },
    {
      key: 'created_at',
      label: t('base.fields.created_at'),
      children: orDash(formatDateTime(record.created_at)),
    },
    {
      key: 'updated_at',
      label: t('base.fields.updated_at'),
      children: orDash(formatDateTime(record.updated_at)),
    },
    ...(record.deleted_at
      ? [
          {
            key: 'deleted_at',
            label: t('user_catalog.collections.fields.deleted_at'),
            children: orDash(formatDateTime(record.deleted_at)),
          },
        ]
      : []),
  ];

  return (
    <Card title={t('base.sections.basic_info')}>
      <Descriptions
        {...verticalDescProps}
        column={{ xs: 1, sm: 2, md: 3 }}
        items={items}
      />
    </Card>
  );
};
